import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/16/solid'
import classNames from 'classnames'

type ToggleSidebarProps = {
    side: 'left' | 'right'
    collapsedVariant?: 'hide' | 'show' | 'full'
    collapsed: boolean
    onToggle: () => void
}

export const ToggleSidebar = ({ side, collapsedVariant, collapsed, onToggle }: ToggleSidebarProps) => {
    const CollapsedIcon = side === 'left' ? ChevronRightIcon : ChevronLeftIcon
    const ExpandedIcon = side === 'left' ? ChevronLeftIcon : ChevronRightIcon

    const ArrowIcon = collapsed ? CollapsedIcon : ExpandedIcon

    return (
        <div
            className={classNames(
                'absolute right-2 top-2 z-10 hidden h-6 w-6 items-center justify-center rounded-full bg-white shadow-sm hover:bg-neutral-50 active:bg-neutral-100 md:group-hover:flex dark:bg-neutral-600 dark:hover:bg-neutral-500 dark:active:bg-neutral-700',
                {
                    '!flex': collapsedVariant !== 'hide' && collapsed,
                    'right-1': side === 'left',
                    'left-1': side === 'right',
                    '!bottom-0 !left-0 !right-0 !top-0 !m-0 !h-auto !w-auto !rounded-none':
                        collapsedVariant === 'full' && collapsed,
                }
            )}
            onClick={onToggle}
        >
            <ArrowIcon className="h-5 w-5" />
        </div>
    )
}
